"use client"

import type { LinkProps as OriginalLinkProps } from "next/link"
import type {
  ButtonProps,
  HTMLRefAttributes,
  IconButtonProps,
  LinkProps as LinkProps,
  Merge,
} from "./ui"
import OriginalLink from "next/link"
import { Button, IconButton, Link } from "./ui"

export interface NextLinkProps extends LinkProps {}

export function NextLink({ ...rest }: NextLinkProps) {
  return <Link as={OriginalLink} {...rest} />
}

export interface NextLinkButtonProps
  extends Omit<Merge<OriginalLinkProps, ButtonProps>, "as" | "ref">,
    HTMLRefAttributes<"a"> {
  external?: boolean
}

export function NextLinkButton({ external, ...rest }: NextLinkButtonProps) {
  return (
    <Button
      as={OriginalLink}
      rel={external ? "noopener" : undefined}
      target={external ? "_blank" : undefined}
      {...rest}
    />
  )
}

export interface NextLinkIconButtonProps
  extends Omit<Merge<OriginalLinkProps, IconButtonProps>, "as" | "ref">,
    HTMLRefAttributes<"a"> {
  external?: boolean
}

export function NextLinkIconButton({
  external,
  ...rest
}: NextLinkIconButtonProps) {
  return (
    <IconButton
      as={OriginalLink}
      rel={external ? "noopener" : undefined}
      target={external ? "_blank" : undefined}
      {...rest}
    />
  )
}
